import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DeferToContextualServerFileSerializer_getInstancebet21aefs4ur as DeferToContextualServerFileSerializer_getInstance } from './DirectServerFileSerializer.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ServerFile___init__impl__jj3mn2(location) {
  return location;
}
function _ServerFile___get_location__impl__ddyqaq($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function ServerFile__toString_impl_4rulpa($this) {
  return 'ServerFile(location=' + $this + ')';
}
function ServerFile__hashCode_impl_qj0ii5($this) {
  return getStringHashCode($this);
}
function ServerFile__equals_impl_4qpzf5($this, other) {
  if (!(other instanceof ServerFile()))
    return false;
  if (!($this === other.location_1))
    return false;
  return true;
}
var ServerFileClass;
function ServerFile() {
  if (ServerFileClass === VOID) {
    class $ {
      constructor(location) {
        this.location_1 = location;
      }
      toString() {
        return ServerFile__toString_impl_4rulpa(this.location_1);
      }
      hashCode() {
        return ServerFile__hashCode_impl_qj0ii5(this.location_1);
      }
      equals(other) {
        return ServerFile__equals_impl_4qpzf5(this.location_1, other);
      }
    }
    initMetadataForClass($, 'ServerFile', VOID, VOID, VOID, VOID, VOID, {0: DeferToContextualServerFileSerializer_getInstance});
    ServerFileClass = $;
  }
  return ServerFileClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  ServerFile as ServerFile2veqsg2df5jtr,
  _ServerFile___init__impl__jj3mn2 as _ServerFile___init__impl__jj3mn21a24gf5791tmu,
  ServerFile__hashCode_impl_qj0ii5 as ServerFile__hashCode_impl_qj0ii51v31c23ib9tv8,
  _ServerFile___get_location__impl__ddyqaq as _ServerFile___get_location__impl__ddyqaq3gnot90we5jhf,
  ServerFile__toString_impl_4rulpa as ServerFile__toString_impl_4rulpa28j1bs1w6h1u6,
};
//endregion

//# sourceMappingURL=ServerFile.mjs.map
